<template>
  <v-card>
    <v-card-title v-if="!smsCodeField">Contact number</v-card-title>
    <v-card-subtitle v-if="!smsCodeField">
      We will reach out to you at this number
    </v-card-subtitle>
    <v-card-text v-if="!smsCodeField">
      <v-text-field
          v-model="phoneNumber"
          name="input-2-3"
          label="4163217654"
          class="input-group--focused"
          prepend-icon="smartphone"
          single-line
          type="number"
      ></v-text-field>
      <v-btn id="get-sign-in-code" :disabled="!phoneNumberValid" class="blue" dark>Submit</v-btn>
    </v-card-text>
    <v-card-text v-if="smsCodeField">
      <h2>Enter code received over text:</h2>
      <v-text-field
          v-model="SMSCode"
          name="input-2-3"
          type="number"
          label="eg. 123456"
          class="input-group--focused"
          prepend-icon="mobile_screen_share"
          single-line
      ></v-text-field>
      <v-btn v-if="resendSMS" @click="onResendCode" class="blue--text mr-3" outlined>Resend Code</v-btn>
      <v-btn v-if="!loading" @click="onConfirmationsResult" :disabled="!SMSCode" class="blue" dark>Submit</v-btn>
      <app-loading v-else></app-loading>
    </v-card-text>
  </v-card>
</template>
<script>
import { getAuth, RecaptchaVerifier, signInWithPhoneNumber  } from 'firebase/auth'
const auth = getAuth()
export default {
  data () {
    return {
      phoneNumber: '',
      codeField: false,
      SMSCode: null,
      smsCodeField: false,
      conformationResult: null,
      resendSMS: false,
      recaptchaVerifier: null
    }
  },
  computed: {
    phoneNumberValid () {
      if (!this.loading &&
          this.phoneNumber.length === 10 &&
          this.phoneNumber !== '') {
        return true
      } else return false
    },
    applicationVerifier () {
      return new RecaptchaVerifier('get-sign-in-code', {
        size: 'invisible',
        callback: (RCToken) => {
          // reCAPTCHA solved, allow signInWithPhoneNumber.
          this.onVarifyNumber(RCToken)
        }
      }, auth)
    },
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  mounted () {
    // Start Firebase invisible reCAPTCHA verifier
    window.recaptchaVerifier = this.applicationVerifier
    this.recaptchaVerifier = window.recaptchaVerifier
    window.recaptchaVerifier.render().then((widgetId) => {
      this.widgetId = widgetId
      window.recaptchaWidgetId = widgetId
    })
  },
  methods: {
    onResendCode () {
      this.resetRC()
      location.reload()
    },
    onlogout () {
      this.$store.dispatch('logout')
    },
    resetRC () {
      this.recaptchaVerifier.recaptcha.reset(this.widgetId)
      //console.log(this.recaptchaVerifier)
    },
    onConfirmationsResult () {
      this.$store.dispatch('setLoading', true)
      this.conformationResult.confirm(this.SMSCode)
          .then(() => {
            console.log(auth.currentUser)
            this.$emit('userVerified', auth.currentUser)
            this.resetRC()
          })
          .catch((error) => {
            this.$store.dispatch('setError', error)
            this.resendSMS = true
            this.$store.dispatch('setLoading', false)
            console.log(error)
          })
    },
    onVarifyNumber () {
      let formatedNumber = '+1' + this.phoneNumber
      //console.log(formatedNumber)
      //console.log(RCToken)
      signInWithPhoneNumber(auth, formatedNumber, this.applicationVerifier)
          .then((confirmationResult) => {
            this.smsCodeField = true
            this.conformationResult = confirmationResult
            // At this point SMS is sent. Ask user for code.
//            alert('A confirmation message was just sent.');
//            let code = window.prompt('Please enter the 6 digit code sent to your phone', 'code in SMS')
//            let code = this.SMSCode
//            console.log(code)
//            return confirmationResult.confirm(code)
          })
          .catch((error) => {
            this.$store.dispatch('setError', error)
            this.phoneNumber = ''
            console.log(error)
          })
    }
  }
}
</script>